import * as url from "url";
import { cookie, storage } from "@region-lib/helper";
const isBrowser = typeof window !== "undefined" && window.location;
const LANG_KEY = "LANG_KEY";
const LANGUAGES = [
  { label: "English", lang: "EN", value: "en-US" },
  { label: "\uD55C\uAD6D\uC5B4", lang: "KO", value: "ko-KR" },
  { label: "\u4E2D\u6587\u7E41\u9AD4", lang: "ZH", value: "zh-TW" },
  { label: "Deutsch", lang: "DE", value: "de-DE" },
  { label: "\u65E5\u672C\u8A9E", lang: "JA", value: "ja-JP" },
  { label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439", lang: "RU", value: "ru-RU" }
];
const LANG_ABBR = LANGUAGES.map((item) => item.value);
function getByCookie() {
  var _a;
  const lang = cookie.get(LANG_KEY);
  return (_a = LANGUAGES.find((item) => item.value === lang)) == null ? void 0 : _a.value;
}
function getByStorage() {
  var _a;
  const lang = storage.get(LANG_KEY);
  return (_a = LANGUAGES.find((item) => item.value === lang)) == null ? void 0 : _a.value;
}
function getByUrl(path) {
  var _a;
  const { pathname } = url.parse(path);
  return (_a = LANGUAGES.find((item) => pathname.includes(item.value))) == null ? void 0 : _a.value;
}
const fixLanguage = (lang) => {
  const langItem = LANGUAGES.find((item) => item.lang === lang.toUpperCase());
  return langItem ? langItem.value : lang;
};
function getLanguage(path) {
  const defaultLang = "en-US";
  if (!isBrowser) {
    if (!path) {
      throw new Error("Unable to detect url, the path parameter cannot be undefined in non-browser environment");
    }
    return getByUrl(path) || defaultLang;
  }
  return getByUrl(path || window.location.href) || getByCookie() || getByStorage() || defaultLang;
}
export { LANGUAGES, LANG_ABBR, LANG_KEY, fixLanguage, getLanguage };
